import {useEffect, useRef} from 'react'

import {Grid} from '@primer/react-brand/esm'

import {ContentfulInlineFootnotesList} from '@github-ui/swp-core/components/contentful/ContentfulInlineFootnotesList'

import {BrandPageContent} from '../../brand/components/BrandPage'

import BackToTop from './_components/BackToTop/BackToTop'
import WebGLAssets from './webgl-utils/assets'

import {AutomationSection} from './_sections/AutomationSection/AutomationSection'
import {CollaborationSection} from './_sections/CollaborationSection/CollaborationSection'
import {CtaSection} from './_sections/CtaSection/CtaSection'
import {CustomerStoriesSection} from './_sections/CustomerStoriesSection/CustomerStoriesSection'
import {HeroSection} from './_sections/HeroSection/HeroSection'
import {SecuritySection} from './_sections/SecuritySection/SecuritySection'
import {homePage} from './content'

export function Home() {
  const assetsRef = useRef<WebGLAssets | null>(new WebGLAssets())

  useEffect(() => {
    let isClosed = false
    const assets = assetsRef.current

    if (assets)
      assets.load(() => {
        if (!isClosed) {
          // All assets loaded
          assets.executeCallbacks()
        }
      })
    return () => {
      isClosed = true
    }
  }, [])

  return (
    <BrandPageContent
      definition={homePage}
      colorMode="dark"
      /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
      className="lp-Home"
      withFootnotes
      footnotesPlacement="inside"
    >
      {({automation, collaboration, cta, customerStories, hero, security}) => (
        <>
          {hero ? <HeroSection assetsRef={assetsRef} contentfulContent={hero} /> : null}

          {automation ? <AutomationSection assetsRef={assetsRef} contentfulContent={automation} /> : null}

          {security ? <SecuritySection assetsRef={assetsRef} contentfulContent={security} /> : null}

          {collaboration ? <CollaborationSection assetsRef={assetsRef} contentfulContent={collaboration} /> : null}

          {customerStories ? (
            <CustomerStoriesSection assetsRef={assetsRef} contentfulContent={customerStories} />
          ) : null}

          {cta ? <CtaSection contentfulContent={cta} /> : null}

          <Grid>
            <Grid.Column span={12}>
              <ContentfulInlineFootnotesList className="pt-0" />
            </Grid.Column>
          </Grid>

          <BackToTop />
        </>
      )}
    </BrandPageContent>
  )
}
